<section class="pt-16 pb-8" *ngIf="post_data.length !== 0">    
    <app-slider [loop]="false" [grabCursor]="true" [breakpoints]="{'0.00': {slidesPerView: 1, spaceBetween: 10}, '@0.75': { slidesPerView: 1, spaceBetween: 10, }, '@1.00': { slidesPerView: 1, spaceBetween: 20, centeredSlides: true }, '@1.50': { slidesPerView: 1, spaceBetween: 20, centeredSlides: true }}" [sliderLength]="post_data.length">
        <swiper-slide [lazy]="true" *ngFor="let data of post_data; let i = index">            
            <div class="flex flex-col gap-8" [ngClass]="{'lg:flex-row': i % 2 === 0, 'lg:flex-row-reverse': i % 2 !== 0}">
                <div class="lg:w-1/2 w-full">
                    <div class="image flex justify-center">
                        <img [src]="(data.immagine + '?type=making-teca' | image)" alt="" class="lg:h-[425px] h-[300px] lg:w-auto w-full lg:object-contain object-cover">
                    </div>
                </div>
                <div class="lg:w-1/2 w-full">
                    <div class="testo flex justify-center flex-col h-full">
                        <h1 class="lg:text-4xl text-xl font-bold mb-8">{{data.titolo}}</h1>
                        <p [innerHTML]="data.descrizione"></p>
                    </div>
                </div>
            </div>            
        </swiper-slide>
    </app-slider>    
</section>

<ng-container *ngIf="post_data.length === 0">
    <section class="pt-16 px-container">        
        <h1 class="lg:text-2xl text-xl font-medium">Nessun dato è stato caricato, visita gli altri post per scoprire di più sul progetto The Making Teca!</h1>        
    </section>        
</ng-container>

<app-slider [loop]="false" [navigation]="false" [grabCursor]="true" [sliderLength]="posts.length" [breakpoints]="{ '0.00': { slidesPerView: 1, spaceBetween: 10 }, '@0.75': { slidesPerView: 2, spaceBetween: 20, }, '@1.00': { slidesPerView: 3, spaceBetween: 20, }, '@1.50': { slidesPerView: 4, spaceBetween: 20 } }" [titolo]="'ALTRI POST'" [titolo_padding]="'pt-16 pb-8'">
    <swiper-slide [lazy]="true" *ngFor="let post of posts" class="cursor-pointer">
        <img [src]="(post.immagine + '?type=making-teca' | image)" alt="Post Making Teca" (click)="onPost(post.id)">
    </swiper-slide>
</app-slider>